import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetTopic } from "../../store/api/topicApi";

function RoleList({ onEdit }) {
  const getTopic = useGetTopic();
  const {
    data: topicData,
    isLoading: isTopicLoading,
    error: topicError,
  } = useQuery({ queryKey: "topic", queryFn: getTopic });

  const data = topicData?.categorys
    ?.map((e, index) => ({
      index: index + 1,
      name: e?.name,
      parentCategory: e?.parentCategory
        ?.map((cat) => cat?.name || "N/A")
        .join(", "),
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Parent Category",
      accessor: "parentCategory",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isTopicLoading} />
    </div>
  );
}

export default RoleList;
